import * as React from 'react'
import styled from 'styled-components'

import HeaderLinkBoxButton from './HeaderLinkBoxButton'
import { colors } from '../../../utils/helpers/colors'
import { BASE_BREAKPOINTS } from '../../../utils/enhancers/withResponsive'
import logoBd from '../../../assets/images/logo-bd.png'
import logoSlbc from '../../../assets/images/logo-slbc.png'
import logoSln from '../../../assets/images/logo-sln.png'

import HeaderLinkBoxButtonConfigs from './headerLinkBoxButtonsConfiguration'

export const LinkBox = styled.li`
  flex: 1;
  border-radius: 4px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.16);
  background-color: ${colors.white};
  margin-left: 12px;
  margin-right: 12px;
  min-height: 176px;

  @media screen and (max-width: ${BASE_BREAKPOINTS.md}px) {
    border-left: none;
    margin-left: 0;
    margin-right: 0;
    margin-top: 8px;
    min-height: 0;

    :first-child {
      margin-top: 0;
    }
  }
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;

  @media screen and (max-width: ${BASE_BREAKPOINTS.md}px) {
    flex-direction: ${props => (props.buttonConfig.hasArrow ? 'column' : 'row')};
    height: initial;
    justify-content: space-between;
    padding-top: 24px;
    padding-bottom: 24px;
    padding-right: 24px;
    padding-left: 24px;
  }
`

export const CustomLink = styled.a`
  text-decoration: none;
  color: ${colors.black};
`

export const LogoImage = styled.img`
  min-height: 40px;
  max-height: 40px;
  margin-bottom: 16px;

  @media screen and (max-width: ${BASE_BREAKPOINTS.md}px) {
    text-align: left;
    margin-bottom: 8px;
  }
`

export const InformationContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: black;
  margin-bottom: ${props => (props.buttonConfig.hasArrow ? '8px' : '16px')};

  @media screen and (max-width: ${BASE_BREAKPOINTS.md}px) {
    text-align: ${props => (props.buttonConfig.hasArrow ? 'center' : 'left')};
    margin-bottom: ${props => (props.buttonConfig.hasArrow ? '8px' : '0px')};
  }
`

export const Title = styled.span`
  font-size: 18px;
  font-weight: 600;
  line-height: 1.33;
  color: ${colors.darkGrey};
`

export const Description = styled.span`
  font-size: 14px;
  line-height: 1.29;
  color: ${colors.darkGrey};
  margin-top: ${props => (props.buttonConfig.hasArrow ? '2px' : '4px')};
`

export const NoAdsEspace = styled.p`
  width: 80%;

  @media screen and (max-width: ${BASE_BREAKPOINTS.md}px) {
    padding: 0;
    text-align: right;
  }
`

const logoDictionary = {
  bd: { id: logoBd, width: 65, height: 40 },
  slbc: { id: logoSlbc, width: 90, height: 40 },
  sln: { id: logoSln, width: 84, height: 40 },
}

const HeaderLinkBox = ({ headerLinkBox }) => {
  const buttonConfig = HeaderLinkBoxButtonConfigs[headerLinkBox.tag]
  const body = (
    <>
      {headerLinkBox.imageId && (
        <LogoImage
          src={logoDictionary[headerLinkBox.imageId].id}
          width={logoDictionary[headerLinkBox.imageId].width}
          height={logoDictionary[headerLinkBox.imageId].height}
          alt="logo"
        />
      )}
      <InformationContainer buttonConfig={buttonConfig}>
        <Title>{headerLinkBox.title}</Title>
        <Description buttonConfig={buttonConfig}>{headerLinkBox.description}</Description>
      </InformationContainer>
      {headerLinkBox.seoLink.adsCount === 0 && <NoAdsEspace>Pas d&apos;annonce en {headerLinkBox.title.toLowerCase()} pour cette localité</NoAdsEspace>}
      {headerLinkBox.seoLink.adsCount !== 0 && <HeaderLinkBoxButton buttonConfig={buttonConfig} link={headerLinkBox.seoLink.text} />}
    </>
  )

  return (
    <LinkBox key={headerLinkBox.tag}>
      {headerLinkBox.seoLink.adsCount !== 0 && (
        <CustomLink href={`${headerLinkBox.seoLink.url}`}>
          <Wrapper buttonConfig={buttonConfig}>{body}</Wrapper>
        </CustomLink>
      )}
      {headerLinkBox.seoLink.adsCount === 0 && <Wrapper buttonConfig={buttonConfig}>{body}</Wrapper>}
    </LinkBox>
  )
}

export default HeaderLinkBox
